/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.DownloadReportsResponse,
  downloadReport: (params: vp.DownloadReportRequest) => void,
  downloadReportAsync: (params: vp.DownloadReportRequest) => Promise<vp.DownloadReportsResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostDownloadReport: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCreateGroup, setShouldCreateGroup] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.DownloadReportRequest>({
    ReportID: '',
  });
  const [response, setResponse] = useState<vp.DownloadReportsResponse>({
    Success: false,
    ErrorMessage: '',
    ReportFile: '',
    ReportName: '',
  });

  useEffect(() => {
    if (!shouldCreateGroup) return () => {};

    const postDownloadReport = async () => {
      setDataFetchingInfo(true, 'downloading report', 'fullScreen');
      const res = await api.postDownloadReport(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCreateGroup) void postDownloadReport();
    setShouldCreateGroup(false);
    return () => {
      source.cancel();
    };
  }, [shouldCreateGroup]);

  return [
    response,
    (_params: vp.DownloadReportRequest) => {
      setParams(_params);
      setShouldCreateGroup(true);
    },
    async (requestParams: vp.DownloadReportRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.postDownloadReport(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        ReportFile: '',
        ReportName: '',
      });
      setShouldCreateGroup(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostDownloadReport);
